<template>
    <v-app  class="login">
          <slot/>
          <footer>Powered by DAS LOKET SOCIAL</footer>
    </v-app>
</template>

<script>
export default {

}
</script>

<style lang="scss">
    body{
        margin: 0;
    }
    .login{
        background-color: #eaecf1!important;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-size: cover !important;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        // @media(max-width:620px){
        //      background-image: url('../assets/background-supernova-mob.png') !important;
        // }
        footer{
            width: 100%;
            text-align: center;
            position: absolute;
            bottom: 5px;
            font-weight: bold;
        }
        
    }

</style>